import React from 'react';
import './hyperlink.scss';

function Hyperlink({ hyperlinkData, origin }) {
  return (
    <a
      className={origin === 'cta' ? 'hyperLink hyperLink--cta' : 'hyperLink'}
      href={hyperlinkData.href}
      target="_blank"
      rel="sponsored"
    >
      {hyperlinkData.copy}
    </a>
  );
}

export default Hyperlink;
